<template>
  <div>
    <f-model
      width="1200px"
      :visible="imgprivew.visible"
      @close="close"
      :closeoutsize="true"
    >
      <div slot="body">
        <img width="100%" :src="imgprivew.src" />
      </div>
    </f-model>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  computed: {
    imgprivew() {
      return this.$store.state.imgprivewData;
    }
  },
  methods: {
    close() {
      console.log(123);
      const parma = {
        visible: false,
        src: ''
      };
      this.$store.commit('setimgprivewData', parma);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/imgprivew/index.vue